'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from 'react';
import { useMediaQuery } from '@/app/hooks/useMediaQuery';
const CONTENT_SWIPE_MIN_DISTANCE = 40;
const CONTENT_SWIPE_AXIS_RATIO = 1.25;
interface UseContentSwipeOptions {
  onSelectPrevious: () => void;
  onSelectNext: () => void;
}
export const useContentSwipe = t0 => {
  const $ = _c(9);
  const {
    onSelectPrevious,
    onSelectNext
  } = t0;
  const isMobile = useMediaQuery("(max-width: 1023px)") ?? false;
  const startRef = useRef(null);
  let t1;
  if ($[0] !== isMobile) {
    t1 = event => {
      if (!isMobile || !event.isPrimary || event.pointerType === "mouse") {
        return;
      }
      startRef.current = {
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };
      event.currentTarget.setPointerCapture(event.pointerId);
    };
    $[0] = isMobile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handlePointerDown = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      startRef.current = null;
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handlePointerCancel = t2;
  let t3;
  if ($[3] !== onSelectNext || $[4] !== onSelectPrevious) {
    t3 = event_0 => {
      const start = startRef.current;
      startRef.current = null;
      if (!start || start.pointerId !== event_0.pointerId) {
        return;
      }
      if (event_0.currentTarget.hasPointerCapture(event_0.pointerId)) {
        event_0.currentTarget.releasePointerCapture(event_0.pointerId);
      }
      const deltaX = event_0.clientX - start.x;
      const deltaY = event_0.clientY - start.y;
      const horizontalDistance = Math.abs(deltaX);
      const verticalDistance = Math.abs(deltaY);
      if (horizontalDistance < CONTENT_SWIPE_MIN_DISTANCE || horizontalDistance < verticalDistance * CONTENT_SWIPE_AXIS_RATIO) {
        return;
      }
      if (deltaX < 0) {
        onSelectNext();
        return;
      }
      onSelectPrevious();
    };
    $[3] = onSelectNext;
    $[4] = onSelectPrevious;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handlePointerUp = t3;
  let t4;
  if ($[6] !== handlePointerDown || $[7] !== handlePointerUp) {
    t4 = {
      handlePointerDown,
      handlePointerUp,
      handlePointerCancel
    };
    $[6] = handlePointerDown;
    $[7] = handlePointerUp;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};